import request from '@/utils/axios'
// 权限按钮
export const getAccessToClassScheduling = () =>
  request({
    url: "/edu_basic/auth/get_course_schedule_config",
    method: "get",
  });

export function ExportCourseSchedulingList(params) {
  return request({
    url: '/course_schedule/auth/export_course_schedule',
    method: 'get',
    params: params
  })
}

export function getFestivalDateList(params) {
  return request({
    url: '/auth/teacherSchedule/get_festival_date_list',
    method: 'get',
    params: params
  })
}

export function getMonthList(params) {
  return request({
    url: '/auth/teacherSchedule/month_list',
    method: 'get',
    params: params
  })
}

export function getWeekList(params) {
  return request({
    url: '/auth/teacherSchedule/week_list',
    method: 'get',
    params: params
  })
}
export function teacherScheduleWeekList(params) {
  return request({
    url: '/auth/teacherSchedule/teacher_schedule_week_list',
    method: 'get',
    params: params
  })
}
export function classroomScheduleWeekList(params) {
  return request({
    url: '/auth/teacherSchedule/classroom_schedule_week_list',
    method: 'get',
    params: params
  })
}
export function classroomScheduleDayList(params) {
  return request({
    url: '/auth/teacherSchedule/classroom_schedule_day_list',
    method: 'get',
    params: params
  })
}
export function classScheduleDayList(params) {
  return request({
    url: '/auth/teacherSchedule/class_schedule_day_list',
    method: 'get',
    params: params
  })
}
export function getClassList(params = {}) {
  return request({
    url: '/auth/teacherSchedule/get_not_finish_class_list',
    method: 'get',
    params: params
  })
}
export function classScheduleWeekList(params) {
  return request({
    url: '/auth/teacherSchedule/class_schedule_week_list',
    method: 'get',
    params: params
  })
}
// /auth//teacherSchedule/classroom_schedule_week_list
export function queryAvailableTeacherList(params) {
  return request({
    url: '/edu_admin/auth/query_available_teacher_list',
    method: 'get',
    params: params
  })
}
export function queryAllClassroomList(params) {
  return request({
    url: '/edu_admin/auth/query_all_classroom_list',
    method: 'get',
    params: params
  })
}
//
//
export function getDayList(params) {
  return request({
    url: '/auth/teacherSchedule/day_list',
    method: 'get',
    params: params
  })
}
export function teacherScheduleDayList(params) {
  return request({
    url: '/auth/teacherSchedule/teacher_schedule_day_list',
    method: 'get',
    params: params
  })
}

export function courseComboboxList(params) {
  return request({
    url: '/auth/course/course_combobox_list',
    method: 'get',
    params: params
  })
}

export function save(data) {
  return request({
    url: '/auth/teacherSchedule/save_signle_course_schedule',
    method: 'post',
    data: data
  })
}
export function edit(data) {
  return request({
    url: '/auth/teacherSchedule/update_signle_course_schedule',
    method: 'post',
    data: data
  })
}

export function classCompleted(data) {
  return request({
    url: '/class/auth/class_completed',
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: 'post',
    data: data
  })
}

export function getNotClassList(data) {
  return request({
    url: '/auth/teacherSchedule/get_not_finish_class_list',
    method: 'get',
    params: data
  })
}

// 批量删除课节接口
export const batchDeleteCourseSchedule = (params) =>
  request({
    url: "/course_schedule/auth/batch_delete_course_schedule",
    method: "post",
    data: params,
  });


